export const isValidFileSize = (file: File) => {
  // ** current ** max upload file size is 1GB
  // size is returned in bytes, divide to get GB
  const validFileSize = file.size / 1000000000 < 1
  return file && validFileSize
}
